// document.addEventListener("click", e=>{
//   if(e.target.classList.contains("sc-tab")){
//     document.querySelectorAll(".sc-tab,.sc-tab-content").forEach(el=>el.classList.remove("active"));
//     e.target.classList.add("active");
//     document.querySelector(`[data-tab-content="${e.target.dataset.tab}"]`).classList.add("active");
//   }
// });
// document.addEventListener("click", function(e){
//   const unitBtn = e.target.closest(".sc-units .unit");
//   if(!unitBtn) return;

//   const wrap = unitBtn.closest(".sc-wrap") || document;

//   wrap.querySelectorAll(".sc-units .unit").forEach(b=>b.classList.remove("active"));
//   unitBtn.classList.add("active");

//   wrap.querySelectorAll(".sc-dynamic-table").forEach(table=>{
//     table.querySelectorAll("td[data-cm]").forEach(td=>{
//       td.textContent = td.dataset[unitBtn.dataset.unit];
//     });
//   });
// });

document.addEventListener("click", e => {
  if (e.target.classList.contains("sc-tab")) {
    document.querySelectorAll(".sc-tab,.sc-tab-content").forEach(el => {
      el.classList.remove("active");
      if (el.classList.contains("sc-tab")) el.setAttribute("aria-selected", "false");
    });
    e.target.classList.add("active");
    e.target.setAttribute("aria-selected", "true");
    
    const content = document.querySelector(`[data-tab-content="${e.target.dataset.tab}"]`);
    if (content) content.classList.add("active");
  }
});

document.addEventListener("click", function(e) {
  const unitBtn = e.target.closest(".sc-units .unit");
  if (!unitBtn) return;

  const wrap = unitBtn.closest(".sc-wrap") || document;

  // TDO-07 FIX: Remove active class AND set aria-pressed to false for all buttons
  wrap.querySelectorAll(".sc-units .unit").forEach(b => {
    b.classList.remove("active");
    b.setAttribute("aria-pressed", "false");
  });
  
  // TDO-07 FIX: Add active class AND set aria-pressed to true for the clicked button
  unitBtn.classList.add("active");
  unitBtn.setAttribute("aria-pressed", "true");

  wrap.querySelectorAll(".sc-dynamic-table").forEach(table => {
    table.querySelectorAll("td[data-cm]").forEach(td => {
      td.textContent = td.dataset[unitBtn.dataset.unit];
    });
  });
});